// Step 1 lives at the variant root; steps 2/3 nest under it. Default variant has no prefix.
//   /join, /join/profile, /join/location
//   /join/test-before-test[/profile|/location]
//   /join/checkup[/profile|/location]

import { POSITIONING_VARIANTS, type PositioningVariant } from '@/constants/funnel';
import { useLocation } from 'react-router-dom';

export const ROUTE_JOIN_FUNNEL_BASE = '/join';

// Synchronous so step components match FunnelGuard on first paint (no sessionStorage race).
export function resolveVariantFromPath(pathname: string): PositioningVariant {
  const segments = pathname.replace(/^\/+|\/+$/g, '').split('/');
  if (segments[0] !== 'join') return 'default';
  const candidate = segments[1];
  if (candidate && (POSITIONING_VARIANTS as readonly string[]).includes(candidate)) {
    return candidate as PositioningVariant;
  }
  return 'default';
}

export function useFunnelVariant(): PositioningVariant {
  const { pathname } = useLocation();
  return resolveVariantFromPath(pathname);
}

export type FunnelStepNumber = 1 | 2 | 3;

const STEP_SLUGS: Record<FunnelStepNumber, string> = {
  1: '',
  2: 'profile',
  3: 'location',
};

export function stepRoutePath(variant: PositioningVariant, step: FunnelStepNumber): string {
  const variantSegment = variant === 'default' ? '' : `/${variant}`;
  const stepSegment = STEP_SLUGS[step];
  if (!stepSegment) {
    return `${ROUTE_JOIN_FUNNEL_BASE}${variantSegment}` || '/';
  }
  return `${ROUTE_JOIN_FUNNEL_BASE}${variantSegment}/${stepSegment}`;
}
